import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Heading, Tag, Text } from '../../../../../components/common';
import * as EmptyStateImages from '../../../../../components/common/EmptyStateImages';
import { MainSource } from '../../../../../constants/Source';
import { NewSearchButtonNames, useTrackSearch } from '../../../../../utils/hooks/bi/useTrachSearch';
import { useTrackSearchAndFiltersAnalytics } from '../../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import {
  ClickOrigins,
  SearchAndFiltersShowAllTargets,
} from '../../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { RouteBuilder } from '../../../../../utils/RouteHelpers';
import styles from './NoResults.scss';
import { IOuter } from './NoResults.types';

export const NoResults: FC<IOuter> = ({ searchQuery }) => {
  const history = useHistory();
  const { trackSearchAndFiltersShowAllClick } = useTrackSearchAndFiltersAnalytics();
  const { trackNewSearchClick } = useTrackSearch();

  const handleAllResultsClick = useCallback(
    async (_, event) => {
      event.stopPropagation();
      history.push(RouteBuilder.Search(MainSource.All, searchQuery));

      await trackSearchAndFiltersShowAllClick({
        target: SearchAndFiltersShowAllTargets.AllResults,
        clickOrigin: ClickOrigins.Search,
      });
    },
    [history, searchQuery, trackSearchAndFiltersShowAllClick],
  );

  const handleNewSearchClick = useCallback(
    (_, event) => {
      event.stopPropagation();

      history.push(RouteBuilder.Source(MainSource.MediaFromWix));

      trackNewSearchClick({
        button_name: NewSearchButtonNames.NewSearch,
      });
    },
    [history],
  );

  return (
    <div className={styles.wrapper}>
      <img src={EmptyStateImages.MediaFromWix} alt="empty state" />
      <Heading size="large" className={styles.title}>
        <FormattedMessage id="empty-state.media-from-wix-no-results" />
      </Heading>
      <Text weight="normal" className={styles.subTitle}>
        <FormattedMessage
          id="empty-state.media-from-wix-no-results-subtitle"
          values={{
            searchQuery: <Text weight="bold">{searchQuery}</Text>,
            allResultsButton: (
              <Tag id="all-results" removable={false} onClick={handleAllResultsClick} dataHook="all-results">
                <FormattedMessage id="empty-state.media-from-wix-no-results-all-results" />
              </Tag>
            ),
            newSearchButton: (
              <Tag id="new-search" removable={false} onClick={handleNewSearchClick} dataHook="new-search">
                <FormattedMessage id="empty-state.media-from-wix-no-results-new-search" />
              </Tag>
            ),
          }}
        />
      </Text>
    </div>
  );
};
